<div class="page-layout emma simple fullwidth">
    <!-- SIDENAV HEADER -->
    <div class="header accent" fxLayout="column" fxLayoutAlign="center center">
        <h2>{{ "SIDEBAR.Views" | translate }}</h2>
    </div>
    <!-- / SIDENAV HEADER -->

    <!-- SIDENAV CONTENT -->
    <div class="content-card">
        <!-- VIEW LIST -->
        <mat-action-list class="views-list">
            <mat-list-item (click)="selectView(null)" [ngClass]="{ selectedItem: !selectedView }">
                <p class="text-truncate">DEFAULT</p>
                <!-- TODO: Localize -->
            </mat-list-item>

            @for (view of views; track view) {
                <mat-list-item [ngClass]="{ selectedItem: isSelectedView(view) }" (click)="selectView(view)">
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
                        @if (!isEditView(view)) {
                            <p class="text-truncate">{{ view.name }}</p>
                        }
                        @if (isEditView(view)) {
                            <mat-form-field floatLabel="never">
                                <input
                                    matInput
                                    placeholder="View Name"
                                    (value)="(view.name)"
                                    [(ngModel)]="editViewName"
                                    (click)="$event.stopPropagation()"
                                />
                            </mat-form-field>
                        }
                        <div>
                            <!-- Edit/remove buttons -->
                            @if (!isEditView(view)) {
                                <button mat-icon-button (click)="editView(view, $event)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            }
                            @if (!isEditView(view)) {
                                <button mat-icon-button (click)="deleteView(view, $event)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                            <!-- Edit custom actions -->
                            @if (isEditView(view)) {
                                <button [disabled]="editViewName.length == 0" mat-icon-button (click)="confirmEdit(view, $event)">
                                    <mat-icon>check</mat-icon>
                                </button>
                            }
                            @if (isEditView(view)) {
                                <button mat-icon-button (click)="cancelEdit(view, $event)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                            }
                        </div>
                    </div>
                </mat-list-item>
            }

            <mat-list-item disableRipple>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="1 0 auto">
                    <!-- Add button -->
                    @if (!addingView) {
                        <button mat-raised-button class="add-view-button" color="primary" (click)="addView()">
                            {{ "SIDEBAR.AddView" | translate }}
                        </button>
                    }
                    <!-- Add name -->
                    @if (addingView) {
                        <mat-form-field floatLabel="never">
                            <input matInput placeholder="View Name" [(ngModel)]="newViewName" />
                        </mat-form-field>
                    }
                    <div>
                        <!-- Add actions -->
                        @if (addingView) {
                            <button [disabled]="newViewName.length == 0" mat-icon-button (click)="confirmAdd()">
                                <mat-icon>check</mat-icon>
                            </button>
                        }
                        @if (addingView) {
                            <button mat-icon-button (click)="cancelAdd()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        }
                    </div>
                </div>
            </mat-list-item>
        </mat-action-list>
        <!-- VIEW LIST -->

        <div class="dashboard-sidebar__section">
            <div class="dashboard-sidebar__section-header">
                <h3>Custom Widgets</h3>
                <button mat-raised-button class="add-view-button" color="primary" (click)="openCustomWidgetDialog()">Add Widget</button>
            </div>

            @if (!selectedView) {
                <p class="dashboard-sidebar__hint">Select a view to place or remove widgets.</p>
            }

            <div class="dashboard-sidebar__widget-list">
                @for (widget of customWidgets; track widget.id) {
                    <div
                        class="dashboard-sidebar__widget-row"
                        [ngClass]="{ 'dashboard-sidebar__widget-row--disabled': !selectedView }"
                        (click)="onWidgetRowClick(widget, $event)"
                    >
                        <div class="dashboard-sidebar__widget-main">
                            <div class="dashboard-sidebar__widget-copy">
                                <div class="dashboard-sidebar__widget-name text-truncate">
                                    {{ widget.name || "Untitled widget" }}
                                </div>
                                <div class="dashboard-sidebar__widget-meta">
                                    {{ widget.primaryMetrics.length }} primary, {{ widget.secondaryMetrics.length }} secondary
                                </div>
                            </div>
                            <div class="dashboard-sidebar__widget-actions">
                                <button mat-icon-button [disabled]="!selectedView" (click)="toggleWidgetInSelectedView(widget, $event)">
                                    <mat-icon>
                                        {{ widgetInSelectedView(widget) ? "star" : "star_border" }}
                                    </mat-icon>
                                </button>
                                <button mat-icon-button (click)="openCustomWidgetDialog(widget, $event)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button (click)="deleteWidget(widget, $event)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <!-- / SIDENAV CONTENT -->
</div>
